import React from "react";
import Div100vh from "react-div-100vh";

import GoBackButton from "@/components/common/buttons/GoBackButton";
import CoinsImg from "@/assets/images/coins-image.svg";

export default function ReferScreen() {
  return (
    <Div100vh className="relative flex flex-col overflow-hidden justify-between">
      <div className="p-10">
        <GoBackButton />
      </div>
      <div className="flex flex-col justify-center -mt-24">
        <img src={CoinsImg} alt="coins" className="scale-50" />
        <div className="px-10 flex flex-col gap-8">
          <span className="text-2xl font-semibold text-[#cccccc]">
            Refer a landlord or tenant & get{" "}
            <span className="font-bold text-[#eeeeee]">₹500</span>
          </span>
          <span className="text-[#999999] text-lg">
            Invite your friends to CirclePe Club & earn 500 INR every time
            someone rents via our platform
          </span>
        </div>
      </div>
      <button className="border rounded-full mx-10 mb-10 py-4 bg-white text-black font-semibold text-lg">Share</button>
    </Div100vh>
  );
}
